import type { InventoryEntityType } from '#types/types';

type ViewModeCapability = {
  table: boolean;
  grid: boolean;
};

const INVENTORY_VIEW_MODE_CAPABILITIES: Partial<Record<InventoryEntityType, ViewModeCapability>> = {
  // Assets (Property) and Portfolios are locked to List (table) view only, so no
  // grid toggle.
  Property: { table: true, grid: false },
  Portfolio: { table: true, grid: false },
  // Shortlists are a list only (owner, 2026-09-28): the gallery view is gone.
  PortfolioFit: { table: true, grid: false },
  Lead: { table: true, grid: false },
};

export function supportsInventoryViewModeToggle(entityType: InventoryEntityType): boolean {
  const capability = INVENTORY_VIEW_MODE_CAPABILITIES[entityType];
  return Boolean(capability?.table && capability?.grid);
}

